var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9517 10.4985C26.6896 9.51497 25.9175 8.74052 24.937 8.47768C23.16 8 16.034 8 16.034 8C16.034 8 8.90799 8 7.13087 8.47768C6.15044 8.74052 5.37823 9.51497 5.11619 10.4985C4.64001 12.2809 4.64001 16 4.64001 16C4.64001 16 4.64001 19.719 5.11619 21.5017C5.37823 22.485 6.15044 23.2595 7.13087 23.5224C8.90799 24 16.034 24 16.034 24C16.034 24 23.16 24 24.937 23.5224C25.9175 23.2595 26.6896 22.485 26.9517 21.5017C27.4279 19.719 27.4279 16 27.4279 16C27.4279 16 27.4279 12.2809 26.9517 10.4985Z",
    fill: "#252323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7034 19.377L19.6593 16.0005L13.7034 12.6237V19.377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0e8ebddea3da92aecbd6c2ff00eec7e2.svg";
export { ForwardRef as ReactComponent };